// src/features/dashboard/WeeklyMealGrid.tsx
import React from "react";
import { Box, Typography, Tooltip } from "@mui/material";
import MealCard from "./MealCard";
import { useNavigate } from "react-router-dom";

interface Recipe {
  recipe_id: number;
  name: string;
  image_url?: string | null;
}

type Meal = {
  meal_id: number;
  meal_type: string;
  recipe: Recipe;
  status?: string;
  completed_at?: string;
  is_leftover?: boolean;
  extra_servings?: number;
  servings?: number;
};

type DayBlock = {
  day: string;
  meals: Meal[];
};

interface WeeklyMealGridProps {
  mealsByDay: DayBlock[];
  planStatus?: string;
  planId?: number;
}

const WeeklyMealGrid: React.FC<WeeklyMealGridProps> = ({ mealsByDay, planStatus, planId }) => {
    const navigate = useNavigate();
    const isPlanPlanned = planStatus === 'planned';

  return (
    <Box>
      {mealsByDay.map((day) => (
        <Box key={day.day} mb={3}>
          {/* Day label */}
          <Typography
            variant="subtitle1"
            fontWeight={600}
            sx={{ mb: 1.5 }}
          >
            {day.day}
          </Typography>

          {/* Meal cards in responsive grid */}
          <Box
            sx={{
              display: 'grid',
              gridTemplateColumns: {
                xs: '1fr',
                sm: 'repeat(2, 1fr)',
                md: 'repeat(3, 1fr)',
              },
              gap: 2,
            }}
          >
            {day.meals.map((meal, idx) => {
              const handleClick = () => {
                if (isPlanPlanned) {
                  navigate(`/meal-plans/${planId}/review`);
                } else {
                  navigate(`/meal/${meal.recipe.recipe_id}?meal_id=${meal.meal_id}`);
                }
              };

              return isPlanPlanned ? (
                <Tooltip
                  key={idx}
                  title="Please approve your meal plan first to view recipe details"
                  arrow
                >
                  <Box>
                    <MealCard
                      mealType={meal.meal_type}
                      recipe={meal.recipe}
                      status={meal.status}
                      completedAt={meal.completed_at}
                      isLeftover={meal.is_leftover}
                      extraServings={meal.extra_servings}
                      servings={meal.servings}
                      onClick={handleClick}
                    />
                  </Box>
                </Tooltip>
              ) : (
                <MealCard
                  key={idx}
                  mealType={meal.meal_type}
                  recipe={meal.recipe}
                  status={meal.status}
                  completedAt={meal.completed_at}
                  isLeftover={meal.is_leftover}
                  extraServings={meal.extra_servings}
                  servings={meal.servings}
                  onClick={handleClick}
                />
              );
            })}
          </Box>
        </Box>
      ))}
    </Box>
  );
};

export default WeeklyMealGrid;
